import { InjectionToken } from '@angular/core';

export const SIDE_DIALOG_DATA = new InjectionToken<any>('SideDialogData');
